export const rentalReportData = [
  {
    key: "1",
    INVOICENO: "#INV12345",
    CAR: "Ford Endeavour",
    CARIMAGE: "car-01.jpg",
    CAROWNER: "Sedan",
    IMAGE: "customer-01.jpg",
    CUSTOMER: "Reuben Keen",
    CUSTOMERNAME: "Client",
    AMOUNT: "$120",
    DATE: "24 Jan 2025",
    STATUS: "Completed",
  },
  {
    key: "2",
    INVOICENO: "#INV12346",
    CAR: "Ferrari 458 MM",
    CARIMAGE: "car-02.jpg",
    CAROWNER: "Convertible",
    IMAGE: "customer-02.jpg",
    CUSTOMER: "William Jones",
    CUSTOMERNAME: "Company",
    AMOUNT: "$85",
    DATE: "19 Dec 2024",
    STATUS: "Confirmed",
  },
  {
    key: "3",
    INVOICENO: "#INV12347",
    CAR: "Ford Mustang",
    CARIMAGE: "car-03.jpg",
    CAROWNER: "Coupe",
    IMAGE: "customer-03.jpg",
    CUSTOMER: "Leonard Jandreau",
    CUSTOMERNAME: "Company",
    AMOUNT: "$250",
    DATE: "11 Dec 2024",
    STATUS: "In Rental",
  },
  {
    key: "4",
    INVOICENO: "#INV12348",
    CAR: "Toyota Tacoma 4",
    CARIMAGE: "car-04.jpg",
    CAROWNER: "Hatchback",
    IMAGE: "customer-04.jpg",
    CUSTOMER: "Adam Bolden",
    CUSTOMERNAME: "Client",
    AMOUNT: "$175",
    DATE: "29 Nov 2024",
    STATUS: "Confirmed",
  },
  {
    key: "5",
    INVOICENO: "#INV12349",
    CAR: "Chevrolet Truck",
    CARIMAGE: "car-05.jpg",
    CAROWNER: "Sedan",
    IMAGE: "customer-05.jpg",
    CUSTOMER: "Harvey Jimenez",
    CUSTOMERNAME: "Company",
    AMOUNT: "$200",
    DATE: "03 Nov 2024",
    STATUS: "Rejected",
  },
  {
    key: "6",
    INVOICENO: "#INV12350",
    CAR: "Etios Carmen",
    CARIMAGE: "car-06.jpg",
    CAROWNER: "Hatchback",
    IMAGE: "customer-06.jpg",
    CUSTOMER: "William Ward",
    CUSTOMERNAME: "Client",
    AMOUNT: "$90",
    DATE: "31 Oct 2024",
    STATUS: "Completed",
  },
  {
    key: "7",
    INVOICENO: "#INV12351",
    CAR: "Acura Sport",
    CARIMAGE: "car-07.jpg",
    CAROWNER: "Crossover",
    IMAGE: "customer-07.jpg",
    CUSTOMER: "Norman Coleman",
    CUSTOMERNAME: "Client",
    AMOUNT: "$160",
    DATE: "15 Oct 2024",
    STATUS: "Confirmed",
  },
  {
    key: "8",
    INVOICENO: "#INV12352",
    CAR: "Kia Soul 2016",
    CARIMAGE: "car-08.jpg",
    CAROWNER: "Delivery",
    IMAGE: "customer-08.jpg",
    CUSTOMER: "Jay Beckman",
    CUSTOMERNAME: "Company",
    AMOUNT: "$230",
    DATE: "26 Sep 2024",
    STATUS: "Rejected",
  },
  {
    key: "9",
    INVOICENO: "#INV12353",
    CAR: "Camaro",
    CARIMAGE: "car-09.jpg",
    CAROWNER: "Station Wagon",
    IMAGE: "customer-09.jpg",
    CUSTOMER: "Francis Harris",
    CUSTOMERNAME: "Client",
    AMOUNT: "$230",
    DATE: "01 Sep 2024",
    STATUS: "Rejected",
  },
  {
    key: "10",
    INVOICENO: "#INV12354",
    CAR: "Toyota Camry",
    CARIMAGE: "car-10.jpg",
    CAROWNER: "Mini Van",
    IMAGE: "customer-10.jpg",
    CUSTOMER: "Renaldo Labarre",
    CUSTOMERNAME: "Company",
    AMOUNT: "$300",
    DATE: "15 Aug 2024",
    STATUS: "In Rental",
  },
];
